import React from 'react';
import Chart from "react-google-charts";
import { useEffect } from 'react';
import imagenDefaultGrafica from "../../img/dark-theme/fake-chart.png"

var initialConfigCommonJS = require("../../js/initialConfigCommon.js")
var analyticsCommonJS = require("../../js/analyticsCommon.js")
var generalCommonJS = require("../../js/generalCommon.js")

const GoogleChartGraphics = (params) => {

    useEffect(() => {    
        console.log("Gráfica cargada correctamente.")        
    },[params]);

    var datosRespuestaTemp = []        
    
    function obtenerDatosAMostrarGrupo(){

        try{
    
            if(localStorage.getItem("lastDashboardData") !== null){
            
                var jsonObjData = JSON.parse(localStorage.getItem("lastDashboardData"))
    
                if (Object.keys(jsonObjData.GeneratorData).length > 0){
                    if(jsonObjData.GeneratorData.GeneratorType === "TRIFASICO"){
                        return ["DATETIME","GeneralWhGeneratorGenerationP1","GeneralWhGeneratorGenerationP2","GeneralWhGeneratorGenerationP3"]
                    }
                    else{
                        return ["DATETIME","GeneralWhGeneratorTOTALGeneration"]
                    }
                }
                else{
                    return ["DATETIME","TotalBulkConsumption"] //Está correcto, es porque al no haber grupo seteo un valor que existe, aunque no se va a mostrar
                }
            }
            else{
                return ["DATETIME","GeneralWhGeneratorTOTALGeneration"]
            }
        }
        catch(error){ return ["DATETIME","GeneralWhGeneratorTOTALGeneration"] }    
    
      }

    function procesarDatosGrafica(){
        if(datosParaEstaGraficaCorrectos()){
            try{
                var objResultados = params.graphsData
                var datosRespuesta = []      

                if ( (typeof objResultados !== 'undefined') && (objResultados.length > 1) ){    

                    if(Object.keys(objResultados[0]).length > 1){

                        var valoresAMostrar = params.valoresEnGrafica
                        
                        if( params.graphicId === "dashboardGraficaGRUPOELECTROGENO" ){ valoresAMostrar = obtenerDatosAMostrarGrupo() }

                        //Obtengo las keys de los ejes
                        var keysResultados = Object.keys(objResultados[0])      
                        var keysOrdenadas = []
                        
                        //Muevo el DATETIME al primer elemento independientemente de cómo me llegue
                        for(var n=0; n < keysResultados.length; n++){                    
                            if(valoresAMostrar.includes(keysResultados[n])){
                                if(keysResultados[n] === "DATETIME"){ 
                                    keysOrdenadas.unshift(keysResultados[n]) 
                                }
                                else{
                                    
                                    if(keysResultados[n] === "FVMaxGenerationEstimation"){

                                        var tipoInstalacion = "false"

                                        if(localStorage.getItem("lastDashboardData") !== null){
                                            tipoInstalacion = JSON.parse(localStorage.getItem("lastDashboardData")).InstallationData.GeneralInfo.EnergyGridConnected
                                        }                                

                                        if(tipoInstalacion === "true"){
                                            keysOrdenadas.push(initialConfigCommonJS.obtenerLiteralAtributo("FVMaxGenerationEstimationConnected")) 
                                        }
                                        else{
                                            keysOrdenadas.push(initialConfigCommonJS.obtenerLiteralAtributo(keysResultados[n])) 
                                        }

                                    }
                                    else{
                                        keysOrdenadas.push(initialConfigCommonJS.obtenerLiteralAtributo(keysResultados[n])) 
                                    }

                                }   
                            }
                        }

                        datosRespuesta.push(keysOrdenadas)
                    
                        var timestampfechaActual = new Date().getTime()
                        var segundosDiferenciaHoraria = parseInt(new Date().getTimezoneOffset()) * 60 * 1000// milisegundos                
                        var timestampFechaActualCorrecta = timestampfechaActual - segundosDiferenciaHoraria                
                        var fechaActual = new Date(timestampFechaActualCorrecta).toISOString().substring(0,10)  
                        
                        var timestampFromDatetime = parseInt(new Date(fechaActual+"T"+params.fromDatetime+":00").getTime())
                        var timestampToDatetime = parseInt(new Date(fechaActual+"T"+params.toDatetime+":59").getTime())
                        var timestampTemp = ""

                        //Ahora agrego los datos
                        var valorTemp = []
                        var hora = ""
                        var keyTemp = ""
                        var unidadAtributo = ""

                        for(var x=0; x < objResultados.length; x++){ //Todos los resultados  
                                
                            valorTemp = []          
                            keyTemp = ""

                            timestampTemp = parseInt(new Date(objResultados[x].DATETIME).getTime())  

                            if( (timestampFromDatetime <= timestampTemp) && (timestampTemp <= timestampToDatetime) ){

                                for(var y=0; y < keysResultados.length; y++){ //Keys de cada resultado                              
                            
                                    unidadAtributo = analyticsCommonJS.obtenerUnidadAtributo(keysResultados[y])

                                    if(valoresAMostrar.includes(keysResultados[y])){
                                        
                                        if(keysResultados[y] === "DATETIME"){                                    
                                            
                                            hora = objResultados[x][keysResultados[y]]
                                            hora = hora.split("T")[1]
                                            hora = hora.split(":")
                                            hora = hora[0]+":"+hora[1]
                                        
                                            valorTemp.unshift(hora)
                                        }
                                        else{

                                            if((keysResultados[y]==="TotalBulkConsumption")){
                                                keyTemp = {v: parseFloat(objResultados[x][keysResultados[y]].replace(/\./g, "")), f: objResultados[x][keysResultados[y]] + " " + unidadAtributo} 
                                            }
                                            else if(                                     
                                            (keysResultados[y]==="WorkingTimeAccumulatedFromDate") || 
                                            (keysResultados[y]==="BatteryVoltage") || 
                                            (keysResultados[y]==="BatteryAmperage") || 
                                            (keysResultados[y]==="CurrentGeneratorTankLevel") ||
                                            (keysResultados[y]==="CurrentGeneratorTankPercentage") ||                                    
                                            (keysResultados[y]==="CurrentGeneratorConsumptionCost") ||                            
                                            (keysResultados[y]==="CurrentGeneratorLitersConsumption") ||                            
                                            (keysResultados[y]==="TodayEnergeticUse") ||                                                        
                                            (keysResultados[y]==="TodayenergyWaste") ||
                                            (keysResultados[y]==="TodayusedEnergyCost") ||
                                            (keysResultados[y]==="TodayenergyRevenue") ||
                                            (keysResultados[y]==="TodaysavingsBalance") ||
                                            (keysResultados[y]==="TodayGivenAwayMoney") ||                            
                                            (keysResultados[y]==="CurrentMonthEnergeticUse") ||                                                        
                                            (keysResultados[y]==="CurrentMonthenergyWaste") ||
                                            (keysResultados[y]==="CurrentMonthusedEnergyCost") ||
                                            (keysResultados[y]==="CurrentMonthenergyRevenue") ||
                                            (keysResultados[y]==="CurrentMonthsavingsBalance") ||
                                            (keysResultados[y]==="CurrentMonthGivenAwayMoney") ||                            
                                            (keysResultados[y]==="YearEnergeticUse") ||                                                        
                                            (keysResultados[y]==="YearenergyWaste") ||
                                            (keysResultados[y]==="YearusedEnergyCost") ||
                                            (keysResultados[y]==="YearenergyRevenue") ||
                                            (keysResultados[y]==="YearsavingsBalance") ||                         
                                            (keysResultados[y]==="SinceRegistrationEnergeticUse") ||                                                        
                                            (keysResultados[y]==="SinceRegistrationenergyWaste") ||
                                            (keysResultados[y]==="SinceRegistrationusedEnergyCost") ||
                                            (keysResultados[y]==="SinceRegistrationenergyRevenue") ||
                                            (keysResultados[y]==="SinceRegistrationsavingsBalance")                         
                                            ){                         
                                                keyTemp = {v: parseFloat(parseFloat(objResultados[x][keysResultados[y]]).toFixed(2)), f: parseFloat(objResultados[x][keysResultados[y]]).toFixed(2) + " " + unidadAtributo}
                                            }
                                            else if( (keysResultados[y]==="TodayTotalGeneration") || 
                                                    (keysResultados[y]==="TodayTotalReactive") || 
                                                    (keysResultados[y]==="Todayconsumption") || 
                                                    (keysResultados[y]==="TodayfromGrid") || 
                                                    (keysResultados[y]==="TodaytoGrid") || 
                                                    (keysResultados[y]==="CurrentMonthTotalGeneration") || 
                                                    (keysResultados[y]==="CurrentMonthTotalReactive") || 
                                                    (keysResultados[y]==="CurrentMonthconsumption") || 
                                                    (keysResultados[y]==="CurrentMonthfromGrid") || 
                                                    (keysResultados[y]==="CurrentMonthtoGrid") || 
                                                    (keysResultados[y]==="YearTotalGeneration") || 
                                                    (keysResultados[y]==="YearTotalReactive") || 
                                                    (keysResultados[y]==="Yearconsumption") || 
                                                    (keysResultados[y]==="YearfromGrid") || 
                                                    (keysResultados[y]==="YeartoGrid") ||  
                                                    (keysResultados[y]==="SinceRegistrationTotalGeneration") || 
                                                    (keysResultados[y]==="SinceRegistrationTotalReactive") || 
                                                    (keysResultados[y]==="SinceRegistrationconsumption") || 
                                                    (keysResultados[y]==="SinceRegistrationfromGrid") || 
                                                    (keysResultados[y]==="SinceRegistrationtoGrid")  ){
                
                                                        keyTemp = {v: parseFloat(objResultados[x][keysResultados[y]].split(".")[0]), f: parseInt(objResultados[x][keysResultados[y]].split(".")[0]).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' }).split(",")[0] + " " + unidadAtributo}                                 
                                            }
                                            else{                                                    
                                                if( (unidadAtributo === "%") || ((unidadAtributo === "W/m²")) ){
                                                    keyTemp = {v: parseFloat(objResultados[x][keysResultados[y]].split(".")[0]), f: objResultados[x][keysResultados[y]].split(".")[0] + " " + unidadAtributo}                                 
                                                }
                                                else{

                                                    if( (objResultados[x][keysResultados[y]] === "") || (objResultados[x][keysResultados[y]] === "N/A")) {
                                                        objResultados[x][keysResultados[y]] = 0
                                                    }

                                                    keyTemp = {v: parseFloat(objResultados[x][keysResultados[y]].replace(".", "")), f: objResultados[x][keysResultados[y]] + " " + unidadAtributo}                                 
                                                }
                                                
                                            }
                                            if(parseInt(keyTemp) < 0){
                                                keyTemp = keyTemp * -1
                                            }
                                            valorTemp.push(keyTemp)
                                        }
                                    }
                                }
                            datosRespuesta.push(valorTemp)

                            datosRespuestaTemp = datosRespuesta

                            }                    
                            
                        }
                    }
                }        

                else{ 
                    //Inicializo la tabla vacia para evitar el mensaje de msegs "Table has no columns" durante la carga
                    datosRespuesta = [["DATETIME","TotalBulkConsumption"],["2022-01-01T00:00:00", 0]] 
                }
            }
            catch(error){
                console.log(error)
                datosRespuesta = [["DATETIME","TotalBulkConsumption"],["2022-01-01T00:00:00", 0]]
            }

            try{

                if(document.getElementById("loader"+params.graphicId).className.includes(" hidden")){
                
                    if(datosRespuesta.length <= 2){                 
                        document.getElementById(params.graphicId).className = document.getElementById(params.graphicId).className.replaceAll(" hidden", "") + " hidden"
                        document.getElementById("NoData"+params.graphicId).className = document.getElementById("NoData"+params.graphicId).className.replaceAll(" hidden", "") 
                    }
                    else{
                        if(params.graphsData.length > 1){                  
                            document.getElementById(params.graphicId).className = document.getElementById(params.graphicId).className.replaceAll(" hidden", "")
                            document.getElementById("NoData"+params.graphicId).className = document.getElementById("NoData"+params.graphicId).className.replaceAll(" hidden", "") + " hidden"
                        }
                        else{                    
                            document.getElementById(params.graphicId).className = document.getElementById(params.graphicId).className.replaceAll(" hidden", "") + " hidden"
                            document.getElementById("NoData"+params.graphicId).className = document.getElementById("NoData"+params.graphicId).className.replaceAll(" hidden", "") 
                        }
                    }   
                }

            }
            catch(error){}
        }
        else{
            datosRespuesta = [["DATETIME","TotalBulkConsumption"],["2022-01-01T00:00:00", 0]]
        }

        return datosRespuesta
    }

    function obtenerTamañoGrafica(){

        var idGrafica = params.graphicId        
        var tamaño = ""

        if( idGrafica === "dashboardGraficaGENERAL" ){ tamaño = { min: 0.00000001 } }
        else if( idGrafica === "dashboardGraficaINSTALACION" ){ tamaño = { min: 0.00000001 } }
        else if( idGrafica === "dashboardGraficaFV" ){ tamaño = { min: 0.00000001 } }
        else if( idGrafica === "dashboardGraficaBATERIAS" ){ tamaño = { max: 100, min: 0.00000001 } }
        else if( idGrafica === "dashboardGraficaGRUPOELECTROGENO" ){ tamaño = { min: 0.00000001 } }
        else if( idGrafica === "dashboardGraficaCOCHE" ){ tamaño = { max: 100, min: 0.00000001 } }
        
        return tamaño
    }
    
    function obtenerAlturaGrafica(){

        var idGrafica = params.graphicId
        var altura = 0

        if( idGrafica === "dashboardGraficaGENERAL" ){ altura = 100 }
        else if( idGrafica === "dashboardGraficaINSTALACION" ){ altura = 200 }
        else if( idGrafica === "dashboardGraficaFV" ){ altura = 200 }
        else if( idGrafica === "dashboardGraficaBATERIAS" ){ altura = 200 }
        else if( idGrafica === "dashboardGraficaGRUPOELECTROGENO" ){ altura = 200 }
        else if( idGrafica === "dashboardGraficaCOCHE" ){ altura = 200 }

        return altura+"px"
    }
    
    function datosParaEstaGraficaCorrectos(){
        
        var resultado = true

        var objResultados = params.graphsData        
        var keysResultados = Object.keys(objResultados[0])        
        var valoresAMostrar = []

        if( params.graphicId === "dashboardGraficaGENERAL" ){ 
            valoresAMostrar = ["DATETIME","TotalBulkConsumption"] 
            try{
                document.getElementById("dashboardGraficaGENERAL").className = document.getElementById("dashboardGraficaGENERAL").className.replaceAll(" pointer", "") + " pointer"
            }
            catch(error){}
        }
        else if( params.graphicId === "dashboardGraficaINSTALACION" ){ valoresAMostrar = ["DATETIME","TotalBulkConsumption","TotalWastedEnergy"] }
        else if( params.graphicId === "dashboardGraficaFV" ){ valoresAMostrar = ["DATETIME","FVMaxGenerationEstimation","GeneralWhFVGeneration"] }
        else if( params.graphicId === "dashboardGraficaBATERIAS" ){ valoresAMostrar = ["DATETIME","GeneralBatteryPercentage"] }
        else if( params.graphicId === "dashboardGraficaGRUPOELECTROGENO" ){ valoresAMostrar = ["DATETIME","GeneralWhGeneratorTOTALGeneration"] }
        else if( params.graphicId === "dashboardGraficaCOCHE" ){ valoresAMostrar = ["DATETIME","ChargeLevel"] }

        var valoresNoExistentesEnResultados = 0

        for(var n=0; n < valoresAMostrar.length; n++){                    
            if(!keysResultados.toString().includes(valoresAMostrar[n])){
                valoresNoExistentesEnResultados = valoresNoExistentesEnResultados + 1
            }
        }

        if(valoresNoExistentesEnResultados > 0){     
            try{
                document.getElementById(params.graphicId).className = document.getElementById(params.graphicId).className.replaceAll(" hidden", "") + " hidden"            
                document.getElementById("NoData"+params.graphicId).className = document.getElementById("NoData"+params.graphicId).className.replaceAll(" hidden", "")             
            }
            catch(error){}

            resultado = false
        }
        else{
            resultado = true
        }

        return resultado
    }

    function obtenerMargenIzquierdo(){
        
        var margenIzquierdo = 0

        if( (params.graphicId === "dashboardGraficaGENERAL") || (params.graphicId === "dashboardGraficaINSTALACION") || (params.graphicId === "dashboardGraficaFV") || (params.graphicId === "dashboardGraficaGRUPOELECTROGENO")){
            margenIzquierdo = 48
        }
        else{
            margenIzquierdo = 30
        }

        return margenIzquierdo

    }

    function obtenerEspaciadoGrafica(){

        var valorEspaciado = 1

        if( generalCommonJS.obtenerTipoPlataforma().includes("Web")){                        
            if(params.graphicId === "dashboardGraficaGENERAL"){
                valorEspaciado = parseInt(datosRespuestaTemp.length / 10)
            }             
            else{
                valorEspaciado = parseInt(datosRespuestaTemp.length / 4)
            }
        }
        else{
            if(params.graphicId === "dashboardGraficaGENERAL"){
                valorEspaciado = parseInt(datosRespuestaTemp.length / 5)
            }             
            else{
                valorEspaciado = parseInt(datosRespuestaTemp.length / 5)
            }
            
        }

        return valorEspaciado

    }

    function obtenerPaddingEjeX(){

        var espaciado = ""

        if(params.graphicId === "dashboardGraficaGENERAL"){
            espaciado = "hAxis" 
        }        
        else{
            espaciado = "hAxisAnalytics"
        }

        return espaciado

    }

 return (
    <>
        
        <div id={params.graphicId} style={{height: obtenerAlturaGrafica(),position: "relative"}} className=' hidden'>
                        
            <Chart
                width={'100%'}
                height={'100%'}
                chartType="AreaChart" //LineChart
                data={procesarDatosGrafica(params.graphicId)}     
                chartLanguage='es'       
                options={{                       
                    region: '002',                     
                    backgroundColor: { fill:'transparent' },
                    crosshair: { selected: { color: "red" } },
                    datalessRegionColor: '#F5F5F5',
                    defaultColor: '#778ba5',
                    chartArea:{ left:obtenerMargenIzquierdo(), top:10, bottom:18, right:18, width:"100%", height:"100%"},
                    curveType: 'function',
                    lineWidth: 2,
                    pointSize: 8,
                    pointsVisible:false,    
                    hAxis: {                                                                                                  
                        textStyle:{ fontName: obtenerPaddingEjeX() },                        
                        showTextEvery: obtenerEspaciadoGrafica()
                    },                                                    
                    vAxis: {                                                                     
                        textStyle:{fontName: 'vAxis'},
                        viewWindow: obtenerTamañoGrafica(),
                        gridlines: { count: 4 }                      
                    },               
                    legend:{                    
                        position: 'none', 
                        alignment: 'center',
                        maxLines: 3,
                        textStyle:{
                            fontSize:14
                        }
                    },
                    tooltip:{
                        isHtml: true,
                        textStyle:{
                            fontSize:0
                        }
                    },                         
                    animation:{
                        startup: false,
                        duration: 0,
                        easing: 'in',
                    },
                    series: {
                        /*
                        0: { color: '#C0392B' }, //ROJO
                        1: { color: '#9B59B6' }, //MORADO
                        2: { color: '#3498DB' }, //AZUL
                        3: { color: '#27AE60' }, //VERDE
                        4: { color: '#F4D03F' }, //AMARILLO
                        5: { color: '#DC7633' }, //NARANJA
                        */
                        0: { color: '#3498DB' }, 
                        1: { color: '#F5B041' },
                        2: { color: '#C0392B' }                    
                    }             
                }}
            />

        </div>
             
        <div id={"NoData"+params.graphicId} className="fake-chart hidden">
            <img className="placeholder" src={imagenDefaultGrafica} alt=""/>
            <div className="message transparent">
                <h1 id="tituloGrafica">Gráfica diaria</h1>
                <p id="descripcionGrafica">Todavía no hay suficiente información para mostrar tu gráfica diaria, en breve aparecerá.</p>                
            </div>
        </div>

        
        <div id={"loader"+params.graphicId} className=" contextual" style={{height: "100px", paddingTop: "15px"}}>
            <progress aria-label={params.Mensaje} style={{display: 'block', position: 'relative', margin: 'auto'}}></progress>
            <label id={params.Id+"Label"} style={{position: 'absolute', textAlign: 'center', marginTop: '100px'}}>{params.Mensaje}</label>      
        </div>
            
    </>
    
  );
}

export default GoogleChartGraphics